<div>
  <mat-accordion
    [togglePosition]="'before'"
    class="d-flex align-content-start gap-3 mt-3"
  >
    <mat-expansion-panel
      to
      id="intelligence-panel"
      class="w-100"
      (opened)="panelOpenState = true"
      (closed)="panelOpenState = false"
      [expanded]="haveFollowUp"
      [disabled]="!haveFollowUp"
    >
      <mat-expansion-panel-header class="d-flex">
        <mat-panel-title
          class="d-flex align-items-center align-content-center gap-2 mt-3 mb-3"
        >
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M10.9921 10.8051C11.9973 10.1359 12.7605 9.16097 13.1687 8.02451C13.577 6.88804 13.6087 5.65036 13.2591 4.49449C12.9095 3.33862 12.1973 2.32593 11.2276 1.60617C10.258 0.886416 9.0825 0.497803 7.87492 0.497803C6.66735 0.497803 5.49184 0.886416 4.52221 1.60617C3.55258 2.32593 2.84032 3.33862 2.49076 4.49449C2.1412 5.65036 2.17288 6.88804 2.58114 8.02451C2.9894 9.16097 3.75255 10.1359 4.75774 10.8051C2.93945 11.4752 1.38659 12.7154 0.330862 14.3404C0.275377 14.4229 0.236837 14.5155 0.217482 14.613C0.198127 14.7105 0.198344 14.8109 0.218119 14.9083C0.237895 15.0057 0.276835 15.0982 0.332676 15.1804C0.388516 15.2627 0.460144 15.333 0.543396 15.3873C0.626647 15.4416 0.719861 15.4788 0.81762 15.4967C0.915378 15.5147 1.01573 15.513 1.11285 15.4919C1.20996 15.4707 1.3019 15.4304 1.38332 15.3734C1.46473 15.3164 1.53401 15.2438 1.58711 15.1598C2.2681 14.1124 3.19995 13.2517 4.29802 12.6559C5.3961 12.0601 6.62562 11.748 7.87492 11.748C9.12423 11.748 10.3538 12.0601 11.4518 12.6559C12.5499 13.2517 13.4817 14.1124 14.1627 15.1598C14.2727 15.3233 14.4427 15.4369 14.6358 15.4761C14.8289 15.5153 15.0297 15.4769 15.1947 15.3693C15.3598 15.2616 15.4758 15.0934 15.5178 14.9008C15.5598 14.7083 15.5243 14.507 15.419 14.3404C14.3633 12.7154 12.8104 11.4752 10.9921 10.8051ZM3.74992 6.12508C3.74992 5.30924 3.99185 4.51171 4.44511 3.83336C4.89837 3.155 5.54261 2.62629 6.29636 2.31408C7.0501 2.00187 7.8795 1.92018 8.67967 2.07935C9.47984 2.23851 10.2148 2.63138 10.7917 3.20827C11.3686 3.78516 11.7615 4.52017 11.9207 5.32034C12.0798 6.12051 11.9981 6.94991 11.6859 7.70365C11.3737 8.4574 10.845 9.10164 10.1667 9.5549C9.4883 10.0082 8.69077 10.2501 7.87492 10.2501C6.78129 10.2488 5.7328 9.81385 4.95948 9.04053C4.18616 8.26721 3.75117 7.21872 3.74992 6.12508ZM23.4506 15.3782C23.284 15.4868 23.081 15.5249 22.8864 15.4839C22.6918 15.4429 22.5214 15.3263 22.4127 15.1598C21.7326 14.1118 20.8008 13.2507 19.7025 12.6551C18.6042 12.0596 17.3743 11.7484 16.1249 11.7501C15.926 11.7501 15.7352 11.6711 15.5946 11.5304C15.4539 11.3898 15.3749 11.199 15.3749 11.0001C15.3749 10.8012 15.4539 10.6104 15.5946 10.4698C15.7352 10.3291 15.926 10.2501 16.1249 10.2501C16.7324 10.2495 17.3322 10.1148 17.8816 9.8555C18.431 9.59623 18.9163 9.21883 19.3029 8.75025C19.6895 8.28167 19.9678 7.73349 20.118 7.14488C20.2682 6.55626 20.2865 5.94174 20.1716 5.34522C20.0568 4.74871 19.8116 4.18492 19.4536 3.69414C19.0956 3.20337 18.6337 2.79772 18.1007 2.50618C17.5678 2.21464 16.977 2.04441 16.3707 2.00765C15.7643 1.97089 15.1573 2.0685 14.5931 2.29352C14.501 2.33329 14.402 2.35422 14.3018 2.35507C14.2016 2.35591 14.1022 2.33666 14.0095 2.29845C13.9169 2.26024 13.8328 2.20385 13.7623 2.1326C13.6918 2.06135 13.6363 1.9767 13.5991 1.88364C13.5619 1.79058 13.5437 1.691 13.5456 1.59079C13.5475 1.49058 13.5695 1.39177 13.6102 1.3002C13.651 1.20862 13.7097 1.12615 13.7828 1.05764C13.856 0.989132 13.9421 0.935984 14.0362 0.901335C15.3275 0.38632 16.7639 0.367787 18.0681 0.84931C19.3723 1.33083 20.452 2.27829 21.0989 3.50891C21.7458 4.73953 21.914 6.16611 21.5711 7.51344C21.2283 8.86078 20.3986 10.0334 19.2421 10.8051C21.0604 11.4752 22.6133 12.7154 23.669 14.3404C23.7776 14.507 23.8156 14.7099 23.7747 14.9045C23.7337 15.0992 23.6171 15.2695 23.4506 15.3782Z"
              fill="#3199D0"
            />
          </svg>
          <h3 class="fw-semibold m-0">Serviço de Acompanhamento</h3>
        </mat-panel-title>
      </mat-expansion-panel-header>

      <span class="ms-2">Selecione uma opção abaixo:</span>
      <div class="row gap-4 m-2 mt-4">
        <div
          (click)="selectBasic()"
          style="cursor: pointer"
          class="col d-flex flex-column border rounded shadow-sm p-2 ps-3"
          [ngClass]="
            dataJobOfferState.followupService === 'basic'
              ? 'bg-primary-subtle'
              : ''
          "
        >
          <h2 class="p-0 m-0 mb-1">Basic</h2>
          <p>3 meses de Acompanhamento</p>

          <h2 class="p-0 m-0 my-2 fw-medium fs-5">R$ 139,00/mês</h2>
          <span class="">Cartão de Crédito </span>
          <button
            class="btn text-primary fw-bold border border-black py-2 mt-4 mb-2"
          >
            <span *ngIf="dataJobOfferState.followupService === 'basic'">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                height="24px"
                viewBox="0 -960 960 960"
                width="24px"
                fill="currentColor"
              >
                <path
                  d="M382-240 154-468l57-57 171 171 367-367 57 57-424 424Z"
                />
              </svg>
              Selecionado</span
            >
            <span *ngIf="dataJobOfferState.followupService != 'basic'"
              >Selecionar</span
            >
          </button>
        </div>

        <div
          (click)="selectSmart()"
          style="cursor: pointer"
          class="col d-flex flex-column border rounded shadow-sm p-2 ps-3"
          [ngClass]="
            dataJobOfferState.followupService === 'smart'
              ? 'bg-primary-subtle'
              : ''
          "
        >
          <div
            class="d-flex mb-2 align-content-center align-items-center gap-2"
          >
            <h2 class="p-0 m-0">Smart</h2>
            <p
              style="font-size: 12px"
              class="m-0 border px-2 rounded fw-bold bg-primary-subtle"
              [ngClass]="
                dataJobOfferState.followupService === 'smart'
                  ? 'border-dark-subtle'
                  : ''
              "
            >
              Mais popular
            </p>
          </div>
          <p>1 ano de Acompanhamento</p>
          <div class="d-flex flex-column mb-2">
            <div class="d-flex gap-2 align-items-center">
              <h2 class="p-0 m-0 fw-medium fs-5">R$ 99,00/mês</h2>
            </div>
          </div>
          <span>Cartão de Credito</span>
          <button
            class="btn bg-primary border border-primary text-white fw-bold py-2 mt-4"
          >
            <span *ngIf="dataJobOfferState.followupService === 'smart'">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                height="24px"
                viewBox="0 -960 960 960"
                width="24px"
                fill="currentColor"
              >
                <path
                  d="M382-240 154-468l57-57 171 171 367-367 57 57-424 424Z"
                />
              </svg>
              Selecionado</span
            >
            <span *ngIf="dataJobOfferState.followupService != 'smart'"
              >Selecionar</span
            >
          </button>
        </div>
      </div>
    </mat-expansion-panel>
  </mat-accordion>
</div>
